import { Routes, Route } from "react-router-dom";
import Services from "./Pages/Services";
import Contact from "./Pages/Contact";
import Header from "./Components/Header";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Booknow from "./Pages/Booknow";

import ThankYou from "./Components/Booknow/Thankyou";
import GrohairLanding from "./Pages/Hairtransplant";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import TermsAndConditions from "./Pages/TermsAndConditions";
import RefundCancellationPolicy from "./Pages/RefundCancellationPolicy";
import CookiePolicy from "./Pages/CookiePolicy";
import CookieConsent from "./Components/CookieConsent";
import ScrollToTop from "./Components/ScrollToTop";

function App() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/booknow" element={<Booknow />} />
        <Route path="/thankyou" element={<ThankYou />} />
        <Route path="/hairtransplant" element={<GrohairLanding/>} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/refund-cancellation-policy" element={<RefundCancellationPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
      </Routes>
      <CookieConsent />
    </>
  );
}

export default App;
